import { render, staticRenderFns } from "./AddFolder.vue?vue&type=template&id=a4960b90"
import script from "./AddFolder.vue?vue&type=script&lang=js"
export * from "./AddFolder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports